/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationLabelSettingResponseData,
  GetOrganizationLabelSettingResponseDataFromJSON,
  GetOrganizationLabelSettingResponseDataFromJSONTyped,
  GetOrganizationLabelSettingResponseDataToJSON
} from './GetOrganizationLabelSettingResponseData'

/**
 *
 * @export
 * @interface GetOrganizationLabelSettingResponse
 */
export interface GetOrganizationLabelSettingResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationLabelSettingResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationLabelSettingResponseData}
   * @memberof GetOrganizationLabelSettingResponse
   */
  data?: GetOrganizationLabelSettingResponseData
}

export function GetOrganizationLabelSettingResponseFromJSON(json: any): GetOrganizationLabelSettingResponse {
  return GetOrganizationLabelSettingResponseFromJSONTyped(json, false)
}

export function GetOrganizationLabelSettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationLabelSettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationLabelSettingResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationLabelSettingResponseToJSON(value?: GetOrganizationLabelSettingResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationLabelSettingResponseDataToJSON(value.data)
  }
}
